import { useNavigate } from 'react-router';

import { classesBuilder } from '@common/helpers';
import BaseButton from '@components/Button/BaseButton';

import styles from './styles.module.scss';
import loginStyles from '@components/LoginAnimation/styles.module.scss';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const onBackBtnClick = () => {
    navigate('/');
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles['error-code']}>
          <span>4</span>
          <div className={styles['zero-wrapper']}>
            <span>0</span>
            <div className={styles['gate-wrapper']}>
              <div
                className={classesBuilder(loginStyles.gate, loginStyles['rotate-loading'], styles['spinning-gate'])}
              />
            </div>
          </div>
          <span>4</span>
        </div>

        <p className={styles.message}>
          Sorry, we can&apos;t find the page you&apos;re looking for. Please click the button below to go back to the
          dashboard.
        </p>

        <BaseButton
          className={styles['back-button']}
          onClick={onBackBtnClick}
        >
          Back to Dashboard
        </BaseButton>
      </div>
    </>
  );
};

export default NotFoundPage;
